import React from 'react';

const ConsultantsProblem = () => {
  return (
    <section className="py-24 px-6">
      <div className="max-w-7xl mx-auto">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-4xl md:text-5xl font-bold mb-6 text-white">
            Built for Experts Who Need to <span className="text-cyan-400">Scale</span>
          </h2>
          
          <p className="text-xl text-gray-300 mb-8 leading-relaxed">
            Consultants, coaches, and trainers are expected to deliver real outcomes — fast, measurable, and repeatable.
          </p>
          
          <p className="text-2xl text-gray-400 italic mb-8">
            But traditional delivery doesn't scale.
          </p>
          
          <div className="p-8 rounded-2xl bg-gradient-to-br from-cyan-900/20 to-blue-900/30 border border-cyan-500/30">
            <p className="text-xl text-white font-semibold">
              Traain gives you the infrastructure to deliver enterprise-grade Traaining, practice, and performance insight — under your brand.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ConsultantsProblem;
